<template>
    <div class="info-panel">
        <p v-if="title" class="info-panel-header">
            <fa icon="info-circle" fixed-width></fa>
            {{ title }}
        </p>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'info-panel',
    props: {
        title: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
// `src/scss/variables.scss` (the project's only SCSS variable file) defines no
// info/blue variant, and Bulma's own `$info-light` / `$info-dark` are computed
// for a light theme, so they cannot be reused on this dark background. These
// are the same values as the `.level-info` palette in
// `src/components/alerts/level.vue`, kept literal but named here.
$info-panel-background: #123347;
$info-panel-color: #c9e6f5;

.info-panel {
    background-color: $info-panel-background;
    color: $info-panel-color;
    border-radius: 4px;
    padding: 1.25rem 1.5rem;

    ::v-deep strong {
        color: inherit;
    }

    ::v-deep code {
        background-color: rgba(0, 0, 0, 0.3);
        color: $info-panel-color;
    }
}

.info-panel-header {
    font-weight: 600;
    font-size: 1.05rem;
    margin-bottom: 0.75rem;
}
</style>
